export default [
  // 题库
  {
    path: '/setting',
    meta: { title: '账号设置' },
    component: () => import('@/views/pages/setting/index'),
  }
  // ,
  // { 
  //   path: '/setting',
  //   component: () => import('@/views/pages/setting/index'),
  //   redirect: '/setting/information',
  //   children: [
  //     {
  //       path: 'information',
  //       name: 'information',
  //       meta: { title: '个人设置' },
  //       component: () => import('@/views/pages/setting/information')
  //     },
  //     {
  //       path: 'security',
  //       name: 'security',
  //       meta: { title: '个人设置' },
  //       component: () => import('@/views/pages/setting/security')
  //     },
  //     {
  //       path: 'preference',
  //       name: 'preference',
  //       meta: { title: '个人设置' },
  //       component: () => import('@/views/pages/setting/preference')
  //     },
  //     {
  //       path: 'identity',
  //       name: 'identity',
  //       meta: { title: '个人设置' },
  //       component: () => import('@/views/pages/setting/identity')
  //     }
  //   ]
  // }
]
